<div class="MainDiv">
	<!--Student/Staff-->
	<div class="RadioGrid">
		<input
			class="CHK"
			type="radio"
			id="Student"
			value="Student"
			name="AudienceMode"
			[(ngModel)]="AudienceMode"
			(ngModelChange)="onAudienceOptionChange($event)"
		/>
		<label for="Student">Student</label>

		<input
			class="CHK LeftMargin"
			type="radio"
			id="Staff"
			value="Staff"
			name="AudienceMode"
			[(ngModel)]="AudienceMode"
			(ngModelChange)="onAudienceOptionChange($event)"
		/>
		<label for="Staff">Staff</label>
	</div>

	<!--Main Selectors-->
	<div class="SelectorGrid">
		<label>Active:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="ActiveID" [(ngModel)]="ActiveID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstActive" [ngValue]="o.ID">
				{{ o.Desc }}
			</option>
		</select>

		<label>Search In:</label>
		<select
			[disabled]="IsLoading() == true"
			class="form-control"
			name="SelectedSchool"
			[(ngModel)]="SelectedSchool"
			(ngModelChange)="onSchoolChange($event)"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstSchool" [ngValue]="o">
				{{ o.Desc }}
			</option>
		</select>

		<label *ngIf="SelectedSchool?.ID == -2">Container:</label>
		<select *ngIf="SelectedSchool?.ID == -2" [disabled]="IsLoading() == true" class="form-control" name="SelectedContainer" [(ngModel)]="SelectedContainer">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstContainer" [ngValue]="o">
				{{ o.Desc }}
			</option>
		</select>

		<label *ngIf="SelectedSchool?.ID == -1">Facility:</label>
		<select *ngIf="SelectedSchool?.ID == -1" [disabled]="IsLoading() == true" class="form-control" name="SelectedFacility" [(ngModel)]="SelectedFacility">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstFacility" [ngValue]="o">
				{{ o.Desc }}
			</option>
		</select>

		<label *ngIf="SelectedSchool?.ID > 0">Group:</label>
		<select
			*ngIf="SelectedSchool?.ID > 0"
			[disabled]="IsLoading() == true"
			class="form-control"
			name="SelectedDynamicGroup"
			[(ngModel)]="SelectedDynamicGroup"
			(ngModelChange)="onDynamicGroupChange($event)"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstDynamicGroup" [ngValue]="o">
				{{ o.DynamicGroupDesc }}
			</option>
		</select>

		<label *ngIf="SelectedSchool?.ID > 0">Value:</label>
		<select
			*ngIf="SelectedSchool?.ID > 0"
			[disabled]="IsLoading() == true"
			class="form-control"
			name="SelectedDynamicValue"
			[(ngModel)]="SelectedDynamicValue"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstDynamicValue" [ngValue]="o">
				{{ o.ListDesc }}
			</option>
		</select>

		<label>Filter:</label>
		<input type="text" class="form-control" [(ngModel)]="FilterText" [disabled]="IsLoading() == true" />
	</div>

	<div class="Buttons">
		<button class="btn btn-primary" [disabled]="IsLoading() == true" (click)="onSearch()">Search</button>
	</div>

	<!--Table-->
	<div>
		<p-table
			#mydt
			[value]="lstTable"
			[loading]="TableLoading"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="single"
			[(selection)]="SelectedPerson"
			dataKey="PersonID"
			(onFilter)="onHandleFilter($event)"
			(onSort)="onHandleSort($event)"
			(onRowSelect)="onRowSelect($event)"
			(onRowUnselect)="onRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<!--INSERT CUSTOM FILTERS HERE-->
					<!--ID-->
					<th>
						<p-columnFilter type="text" field="ID" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>
					<!--FirstName-->
					<th>
						<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>
					<!--LastName-->
					<th>
						<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<!--INSERT CUSTOM COLUMNS HERE-->
					<th pSortableColumn="ID">ID<p-sortIcon field="ID"></p-sortIcon></th>
					<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
					<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-Person>
				<tr [pSelectableRow]="Person">
					<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ Person[col.field] }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>

	<!--Person Extended Info-->
	<div>
		<caass-manual-selector-extended-info [AudienceMode]="AudienceMode" [SelectedPerson]="SelectedPerson" [FacilityID]="FacilityID">
		</caass-manual-selector-extended-info>
	</div>
</div>
